module.exports = __webpack_public_path__ + "static/media/wheels.30c6d07a.png";